import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
    return twMerge(clsx(inputs));
}

export function formatDate(dateString) {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    });
}

export function formatDateTime(dateString) {
    const date = new Date(dateString);
    return date.toLocaleString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });
}

export function getScoreColor(score) {
    if (score >= 0.7) return 'text-emerald-600';
    if (score >= 0.5) return 'text-amber-600';
    if (score >= 0.3) return 'text-orange-600';
    return 'text-red-600';
}

export function getScoreBgColor(score) {
    if (score >= 0.7) return 'bg-emerald-500';
    if (score >= 0.5) return 'bg-amber-400';
    if (score >= 0.3) return 'bg-orange-500';
    return 'bg-red-500';
}

export function getSeverityColor(severity) {
    switch (severity) {
        case 'critical':
            return 'bg-red-100 text-red-800 border-red-200';
        case 'high':
            return 'bg-orange-100 text-orange-800 border-orange-200';
        case 'medium':
            return 'bg-amber-100 text-amber-800 border-amber-200';
        case 'low':
            return 'bg-emerald-100 text-emerald-800 border-emerald-200';
        default:
            return 'bg-stone-100 text-stone-800 border-stone-200';
    }
}

export function getMoodEmoji(mood) {
    const emojis = {
        1: '😔',
        2: '😕',
        3: '😐',
        4: '🙂',
        5: '😊',
    };
    return emojis[mood] || '😐';
}

export function getMoodLabel(mood) {
    const labels = {
        1: 'Very Low',
        2: 'Low',
        3: 'Neutral',
        4: 'Good',
        5: 'Great',
    };
    return labels[mood] || 'Neutral';
}

export function capitalizeFirst(str) {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export function truncateText(text, maxLength = 100) {
    if (!text || text.length <= maxLength) return text;
    return text.slice(0, maxLength) + '...';
}
